import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Diagram"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M13.5 12H20.25C20.6642 12 21 11.6642 21 11.25C21 6.69365 17.3063 3 12.75 3C12.3358 3 12 3.33579 12 3.75V10.5C12 11.3284 12.6716 12 13.5 12ZM19.455 10.5H13.5V4.54499C16.6317 4.89649 19.1035 7.36825 19.455 10.5ZM9.75 22.5C5.19365 22.5 1.5 18.8063 1.5 14.25C1.5 9.69365 5.19365 6 9.75 6C10.1642 6 10.5 6.33579 10.5 6.75V13.5H17.25C17.6642 13.5 18 13.8358 18 14.25C18 18.8063 14.3063 22.5 9.75 22.5ZM3.00099 14.5028C2.87047 10.9706 5.48701 7.93584 8.99999 7.54499V13.5C8.99999 14.3284 9.67157 15 10.5 15H16.455C16.0641 18.513 13.0294 21.1295 9.49714 20.999C5.96489 20.8685 3.13151 18.0351 3.00099 14.5028Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Diagram.vue"]]);
